import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import { searchBikesByFilters } from '../../requests/search_bikes_by_params';
import { searchBikesSuccess, searchBikesFailure, searchBikesCountSuccess } from '../actions/search_bikes.actions';
import { SEARCH_BIKES_REQUEST } from '../constants/search_bikes.constants';

function* searchBikesSagaRequest({ params }) {
    const where_condition = yield select(state => state.PlatformManagement.Bike_management.where_condition);
    const pagination = yield select(state => state.PlatformManagement.Bike_management.pagination);


    const params_req = {
        ...params, filters: where_condition, skip: (pagination.page !== 0 ? pagination.page - 1 : pagination.page) * pagination.pageSize, limit: pagination.pageSize,
    };
    const params_count_req = { ...params, filters: where_condition, method: 'count' };

    const response = yield call(searchBikesByFilters, params_req);
    const response_count = yield call(searchBikesByFilters, params_count_req);

    if (response.result) {
        yield put(searchBikesSuccess(response.options));
    } else {
        message.error(response.error.message || 'Error while searching bikes, please contact admin');
        yield put(searchBikesFailure(response.error));
    }

    if (response_count.result) {
        yield put(searchBikesCountSuccess(response_count.options.amount));
    } else {
        yield put(searchBikesCountSuccess(response_count.error));
        message.error(response_count.error.message || 'Error while searching bikes, please contact admin');
    }
}

export default function* searchBikesSaga() {
    yield takeEvery(SEARCH_BIKES_REQUEST, searchBikesSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_bikes.saga.js